<template>
    <vx-card :title='$t("PlannedAbsence")' collapse-action>
        <div class="mt-6" v-if="absences !== undefined">
            <vs-table v-model="selectedAbsence" @selected="handleSelected" :data="absences">
                <template slot="thead">
                    <vs-th>{{$t("StartTime")}}</vs-th>
                    <vs-th>{{$t("EndTime")}}</vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                        <vs-td :data="data[indextr].start">
                            {{moment(data[indextr].start).format('DD/MM/YYYY')}}
                        </vs-td>
                        <vs-td :data="data[indextr].end">
                            {{moment(data[indextr].end).format('DD/MM/YYYY')}}
                        </vs-td>

                        <vs-td :data="data[indextr].status">
                            <vs-chip v-if="data[indextr].status === 0" color="primary">{{$t("Waiting")}}</vs-chip>
                            <vs-chip v-else-if="data[indextr].status === 1" color="success">{{$t("Confirmed")}}</vs-chip>
                            <div v-else-if="data[indextr].status === 2" style="display: flex">
                                <vx-tooltip :text="data[indextr].denial_reason">
                                    <vs-chip color="danger">{{$t("Rejected")}}</vs-chip>
                                </vx-tooltip>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>

        <vs-popup :title="$t('Edit')" :active.sync="editAbsencePrompt">
            <p class="mt-6">{{$t("StartTime")}}</p>
            <flat-pickr :disabled="editAbsence.status !== 0" :config="configDateTimePicker" v-model="editAbsence['start']"></flat-pickr>
            <p class="mt-6">{{$t("EndTime")}}</p>
            <flat-pickr :disabled="editAbsence.status !== 0" :config="configDateTimePicker" v-model="editAbsence['end']"></flat-pickr>

            <p class="mt-6">{{$t("Description")}}</p>
            <vs-textarea :disabled="editAbsence.status !== 0" v-model="editAbsence['notes']" class="w-full" />
            <vs-divider/>
            <vs-button :disabled="editAbsence.status !== 0" style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editAbsenceRequest">{{$t("Change")}}</vs-button>
            <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeAbsenceRequest">{{$t("Delete")}}</vs-button>
        </vs-popup>

    </vx-card>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        components: {
            flatPickr,
        },
        props: {
            userId: {
                type: Number,
                required: true
            },
        },
        data() {
            return {

                selectedAbsence: {},

                absences: [],
                newAbsence: {},
                editAbsence: {},
                editAbsencePrompt: false,
                configDateTimePicker: {
                    enableTime: false,
                    dateFormat: 'Y-m-d',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },
            }
        },
        methods: {
            handleSelected(tr) {
                if (tr.status === 0) {
                    this.editAbsence = tr;
                    this.editAbsencePrompt = true;
                }else{
                    this.selectedAbsence = {}
                }

            },
            updateAbsences() {
                const thisIns = this;
                this.$http.get('/api/v1/profile/absence/')
                    .then(function (response) {
                        thisIns.absences = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            editAbsenceRequest() {
                const thisIns = this;
                this.$http.put('/api/v1/profile/absence/' + this.selectedAbsence.id, {
                    start: thisIns.moment(thisIns.editAbsence.start).format(),
                    end: thisIns.moment(thisIns.editAbsence.end).format(),
                    notes: thisIns.editAbsence.notes
                }).then(function () {
                    thisIns.updateAbsences();
                    thisIns.editAbsencePrompt = false;
                }).catch(function (error) {
                    thisIns.editAbsencePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeAbsenceRequest(){
                const thisIns = this;
                this.$http.delete('/api/v1/profile/absence/' + this.selectedAbsence.id)
                    .then(function () {
                        thisIns.updateAbsences();
                        thisIns.editAbsencePrompt = false;
                    }).catch(function (error) {
                    thisIns.editAbsencePrompt = false;
                    thisIns.$vs.notify({
                        title: 'Error',
                        text: error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                });
            }
        },
        watch: {
            editAbsencePrompt: function () {
                if(!this.editAbsencePrompt){
                    this.selectedAbsence = {}
                }
            }
        },
        created() {
            this.updateAbsences();
        }
    }

</script>
